import type { ChatExecution } from "@stockline/shared/types/ai/chat-execution"
import type { OfflineResourceConfig } from "../../../types"
import { CHAT_EXECUTION_TABLE } from "./db"

export const chatExecutionConfig: OfflineResourceConfig<ChatExecution> = {
  name: "chat-executions",
  // STK-1324: deferred, non-blocking -- hydrated via the SSE replay handshake
  // (cursor=0 full-table replay) AFTER readiness, not the cold-start waves.
  tier: "background",
  endpoints: {
    full: "/api/v2/chat-executions",
    delta: "/api/v2/chat-executions/changes",
    push: "/api/v2/chat-executions/changes",
  },
  tableName: CHAT_EXECUTION_TABLE,
  primaryKey: "id",
  indexes: {
    sessionId: "sessionId",
    companyId: "companyId",
    status: "status",
    createdAt: "createdAt",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
